<template>
  <div class="header-checkout">
    <div class="Container">
      <div class="PageContent">
        <div class="logo">
          <a href="/" aria-label="Go to home page">
            <img src="//cdn.shopify.com/s/files/1/0013/5662/8070/files/logo_7bd1c380-37ac-43d5-9689-8e71886b1127.png?v=1665471513&amp;width=270" alt="C.KRUEGER'S">
          </a>
        </div>
        <ul class="breadcrumbs">
          <li>
            <a href="/cart">Cart</a>
          </li>
          <li>
            Shipping
          </li>
          <li>
            <span>Payment</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>